// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"bike-alarm_formWrapper__498h8","disclaimerWrapper":"bike-alarm_disclaimerWrapper__TxQ47"};